import React, { useEffect, useState } from 'react'
import { Col, Row } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import RenderAssessmentForm from './RenderAssessmentForm'

export default function MAndESelfForm({
  schema: _schema,
  unauthen,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  setAssessmentResult = () => {},
  setAssessmentBasicResult = () => {},
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [position, setPosition] = useState(_schema?.position?.value)
  const [result, setResult] = useState(new Map())
  const [basicInfoResult, setBasicInfoResult] = useState(new Map())
  const [extendResult, setExtendResult] = useState(0)

  useEffect(() => {
    // const count = Array.from(basicInfoResult.keys()).filter((key) =>
    //   /^BS_Q\d+-O\d+_E\d+$/.test(key)
    // ).length

    setExtendResult(basicInfoResult?.get('BS_Q1')?.split(',')?.length || 0)
  }, [basicInfoResult])

  return (
    <>
      <Row style={{ marginTop: 10 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <InputSelectForm
            schema={formSchema.position}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onChange={(value) => {
              setPosition(value)
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <InputForm
            schema={formSchema.otherPosition}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            disabled={position != '99'}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <RenderAssessmentForm
          resultKey="basicInfos"
          assessments={formSchema.basicInfos || []}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          setAssessmentResult={(data) => {
            if (unauthen) {
              setAssessmentBasicResult(data)
            } else {
              setBasicInfoResult(data)
            }
          }}
        />
      </Row>

      <Row style={{ marginTop: 10 }}>
        <RenderAssessmentForm
          assessments={formSchema.assessments || []}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          // setAssessmentResult={setResult}
          setAssessmentResult={(data) => {
            if (unauthen) {
              setAssessmentResult(data)
            } else {
              setResult(data)
            }
          }}
        />
      </Row>
      {!unauthen && (
        <Row style={{ textAlign: 'center' }}>
          <b>
            <label
              style={{
                color:
                  (result?.size || 0) + (basicInfoResult?.size || 0) ==
                  formSchema.totalAssessment + extendResult
                    ? '#2da888'
                    : '#fb8a81',
              }}
            >
              <h4>
                {(result?.size || 0) + (basicInfoResult?.size || 0)} /{' '}
                {formSchema.totalAssessment + extendResult}
              </h4>
            </label>
          </b>
        </Row>
      )}
    </>
  )
}
